////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const kioskDiagnostic = {
	resetDataKioskDiagnostic: () => ({
		type: ActionsTypes.RESET_DATA_KIOSK_DIAGNOSTIC,
	}),
	postKioskDiagnostic: (idKioskProduction, filters = {}, queryParams = { page: '0', size: '250' }) => ({
		type: ActionsTypes.POST_KIOSK_DIAGNOSTIC,
		payload: {
			idKioskProduction,
			filters,
			queryParams,
		},
	}),
	postKioskDiagnosticSuccess: (data) => ({
		type: ActionsTypes.POST_KIOSK_DIAGNOSTIC_SUCCESS,
		payload: {
			data,
		},
	}),
	postKioskDiagnosticFaillure: (error) => ({
		type: ActionsTypes.POST_KIOSK_DIAGNOSTIC_FAILURE,
		payload: {
			error,
		},
	}),
}

export default kioskDiagnostic
